import { DbSignedLicense, SignedLicense } from "./License";
import { requireEvidenceDatabase } from "./getDatabase";
import { ISODateTimeString, UUID } from "./DatabaseTypes";
import { throwIfSignedLicenseDoesNotHaveValidSignature, validateSignedLicense } from "./LicenseValidation";
import { LicenseAddedToDatabase, LicenseDeletedFromDatabase } from "../StateEvents";

export class DbLicensesTable {

	static loadUnvalidatedLicenses = async (includeExpired: boolean = false) => {
		const db = await requireEvidenceDatabase();
		const unvalidatedLicenses = await db.getAll("licenses");
		if (includeExpired) {
			return unvalidatedLicenses;
		}
		const nowIso = new Date().toISOString();
		return unvalidatedLicenses.filter( license => license.whenExpiresIso > nowIso);
	}

	static loadValidLicenses = async (includeExpired: boolean = false) => {
		const unvalidatedLicenses = await this.loadUnvalidatedLicenses(includeExpired);
		return (await Promise.all(
			unvalidatedLicenses.map( license => (validateSignedLicense(license).then( valid => valid ? license : undefined) ) )
		)).filter( l => l != null);
	}

	static loadLicenseByUuid = async (licenseUuid: UUID) => {
		const db = await requireEvidenceDatabase();
		const signedLicense = await db.get("licenses", licenseUuid);
		if (signedLicense == null) return undefined;
		if (!validateSignedLicense(signedLicense)) {
			return undefined;
		}
		return signedLicense;
	}

	static addLicense = async (license: SignedLicense) => {
		const validSignedLicense = await throwIfSignedLicenseDoesNotHaveValidSignature(license);
		const db = await requireEvidenceDatabase();
		const dbSignedLicense: DbSignedLicense = {...validSignedLicense,whenAddedIso: ISODateTimeString()};
		await db.add("licenses", dbSignedLicense);
		LicenseAddedToDatabase.send({signedLicense: dbSignedLicense});
		return dbSignedLicense;
	}

	static deleteLicense = async ({licenseUuid}: {licenseUuid: UUID}) => {
		const db = await requireEvidenceDatabase();
		await db.delete("licenses", licenseUuid);
		LicenseDeletedFromDatabase.send({licenseUuid});
	}

}